import TeamDetailsComponent from "../TeamDetailsComponent.vue";

export default [
    {
        path: "/team/:roleId",
        name: "TeamDetails",
        component: TeamDetailsComponent,
        meta: {
            layout: "default",
        },
    },
];
